'use strict';

module.exports = {
  eras: ['公元前', '公元'],
  months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  shortMonths: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  weekdays: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  shortWeekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  veryShortWeekdays: ['日', '一', '二', '三', '四', '五', '六'],
  ampms: ['上午', '下午'],
  datePatterns: ['yyyy\'年\'M\'月\'d\'日\' EEEE', 'yyyy\'年\'M\'月\'d\'日\'', 'yyyy-M-d', 'yy-M-d'],
  timePatterns: ['ahh\'时\'mm\'分\'ss\'秒\' \'GMT\'Z', 'ahh\'时\'mm\'分\'ss\'秒\'', 'H:mm:ss', 'ah:mm'],
  dateTimePattern: '{date} {time}'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/gregorian-calendar-format/lib/locale/zh_CN.js
 ** module id = 130
 ** module chunks = 0
 **/